import { Component, inject } from '@angular/core';
import { FaunaClassService } from '../proxy/planning/controllers';
import { ListService } from '@abp/ng.core';
import {
  CardComponent,
  CardBodyComponent,
  ConfirmationService,
} from '@abp/ng.theme.shared';
import {
  FaunaClassCreateDto,
  FaunaClassDto,
  FaunaClassExcelDownloadDto,
  FaunaClassUpdateDto,
} from '../proxy/planning/dtos/fauna-class';
import { FAUNACLASS_CONFIG, FAUNACLASS_FIELDS } from './fauna-class.config';
import { BaseCrudComponent, CrudPage, GenericForm } from '@zendra/shared';

@Component({
  selector: 'app-fauna-class',
  imports: [
    CardComponent,
    CardBodyComponent,
    CrudPage,
    GenericForm,
  ],
  providers: [ListService, FaunaClassService, ConfirmationService],
  templateUrl: './fauna-class.html',
  styleUrl: './fauna-class.scss',
})
export class FaunaClass extends BaseCrudComponent<
  FaunaClassDto,
  FaunaClassCreateDto,
  FaunaClassUpdateDto,
  FaunaClassExcelDownloadDto
> {
  service = inject(FaunaClassService);
  config = FAUNACLASS_CONFIG;
  fields = FAUNACLASS_FIELDS;

  protected prepareUpdateDto(data: any, selected: FaunaClassDto): FaunaClassUpdateDto {
    return {
      name: data.name,
      code: data.code,
      concurrencyStamp: selected.concurrencyStamp,
    };
  }

  protected getEntityName(): string {
    return 'FaunaClass';
  }
}
